"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useAwaitableNavigate = void 0;
const tslib_1 = require("tslib");
const react_1 = require("@remix-run/react");
const react_2 = tslib_1.__importDefault(require("react"));
const useAwaitableNavigate = () => {
    const navigate = (0, react_1.useNavigate)();
    const location = (0, react_1.useLocation)();
    const resolveFunctionsRef = react_2.default.useRef([]);
    const resolveAll = () => {
        resolveFunctionsRef.current.forEach(resolve => resolve());
        resolveFunctionsRef.current.splice(0, resolveFunctionsRef.current.length);
    };
    // location.key will change even when navigating to the same url,
    // so we will successfully resolve in that case as well
    react_2.default.useEffect(() => {
        resolveAll();
    }, [location]);
    return (to) => {
        return new Promise(res => {
            resolveFunctionsRef.current.push(res);
            navigate(to);
        });
    };
};
exports.useAwaitableNavigate = useAwaitableNavigate;
